module.exports = __webpack_public_path__ + "static/media/secai-greenblack.34d92ceb.png";